import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
import {
  CurrentDates,
  InitialDates,
} from '../_components/molecules/NewEditDuration';
import {
  EmployerGroups,
  Reports,
} from '../core-utils/helper-utils/reportsWorkFlowHelper';
import {
  EmailSchedulerType,
  emailSchedulerDefaultObject,
} from '../core-utils/helper-utils/emailSchedulerHelper';

export class CustomReportsStore {
  id: string = '';
  reportName: string = '';
  reportsData: Reports[] = [];
  employerGroups: EmployerGroups[] = [];
  isEdit: boolean = false;
  planPeriod: InitialDates = {
    start_month: '',
    end_month: '',
    plan_start_month: '',
    start_year: 0,
    end_year: 0,
    plan_end_month: '',
    recent_plan_year: 0,
  };
  currentDates: CurrentDates = {
    startDate: '',
    endDate: '',
  };
  downloadfrequency: string = '';
  emailSchedulerData: EmailSchedulerType = emailSchedulerDefaultObject;

  constructor() {
    makeObservable(this, {
      id: observable,
      reportName: observable,
      reportsData: observable,
      employerGroups: observable,
      isEdit: observable,
      planPeriod: observable,
      currentDates: observable,
      downloadfrequency: observable,
      emailSchedulerData: observable,
      setCustomReportsData: action,
      removeCustomReportsData: action,
    });

    makePersistable(this, {
      name: 'CustomReportsStore',
      properties: [
        'id',
        'reportName',
        'reportsData',
        'employerGroups',
        'isEdit',
        'planPeriod',
        'currentDates',
        'downloadfrequency',
        'emailSchedulerData',
      ],
      storage: window.localStorage,
    });
  }

  setCustomReportsData(
    id: string,
    reportName: string,
    reportsData: Reports[],
    employerGroups: EmployerGroups[],
    isEdit: boolean,
    planPeriod: InitialDates,
    currentDates: CurrentDates,
    downloadfrequency: string,
    emailSchedulerData: EmailSchedulerType,
  ) {
    this.id = id;
    this.employerGroups = employerGroups;
    this.isEdit = isEdit;
    this.reportName = reportName;
    this.planPeriod = planPeriod;
    this.reportsData = reportsData;
    this.downloadfrequency = downloadfrequency;
    this.emailSchedulerData = emailSchedulerData;
    this.currentDates = currentDates;
  }

  removeCustomReportsData() {
    this.id = '';
    this.employerGroups = [];
    this.isEdit = false;
    this.reportName = '';
    this.reportsData = [];
    this.planPeriod = {
      start_month: '',
      end_month: '',
      plan_start_month: '',
      start_year: 0,
      end_year: 0,
      plan_end_month: '',
      recent_plan_year: 0,
    };
    this.currentDates = {
      startDate: '',
      endDate: '',
    };
    this.downloadfrequency = '';
    this.emailSchedulerData = emailSchedulerDefaultObject;
  }
}
export default CustomReportsStore;
